import React, { useState } from 'react';
import SelectInput from './SelectInput';

const MonthSelect = ({ initialMonth, onMonthChange }) =>
{
  const currentMonth = new Date().getMonth();

  // Generate an array of months
  const months = [1, 2, 3, 4,5,6,7,8,9,10,11,12];

  // Set up the initial selected year in state
  const [selectedMonth, setSelectedMonth] = useState(initialMonth || currentMonth);

  // Handle selection change
  const handleChange = (event) => {
    const newMonth = parseInt(event.target.value, 10);
    setSelectedMonth(newMonth);
    if (onMonthChange) {
      onMonthChange(newMonth);
    }
  };

  return (
    <SelectInput default={selectedMonth.toString()}
        label="Month"
        onChange = {handleChange}
        options = {months}
        ref={e => e}
        />
  );    
}

export default MonthSelect;